export const commonDateEn = {
  dateRange: '{{from}} - {{to}}',
  dateRangeShort: '{{from}}-{{to}}',
  day: 'day',
  days: 'days',
  duration: '{{from}} - {{to}} ({{duration}})',
  endDate: 'End date',
  futureDistance: 'in {{value}}',
  lessThanOneDay: 'less than a day',
  lessThanOneMonth: 'less than a month',
  month: 'month',
  months: 'months',
  pastDistance: '{{value}} ago',
  periodDistance: '{{value}}',
  startDate: 'Start date',
  week: 'week',
  weeks: 'weeks',
  year: 'year',
  years: 'years'
};